var Color = /* @__PURE__ */ ((Color2) => {
  Color2["DEFAULT_RED"] = "default-red";
  Color2["LIGHT_PURPLE"] = "light-purple";
  Color2["DARK_PURPLE"] = "dark-purple";
  Color2["TWITCH_PURPLE"] = "twitch-purple";
  Color2["LIGHT_BLUE"] = "light-blue";
  Color2["DARK_BLUE"] = "dark-blue";
  Color2["LIGHT_AQUA"] = "light-aqua";
  Color2["DARK_AQUA"] = "dark-aqua";
  Color2["LIGHT_GREEN"] = "light-green";
  Color2["DARK_GREEN"] = "dark-green";
  Color2["LIGHT_YELLOW"] = "light-yellow";
  Color2["DARK_YELLOW"] = "dark-yellow";
  Color2["LIGHT_GREY"] = "light-grey";
  Color2["MEDIUM_GREY"] = "medium-grey";
  Color2["DARK_GREY"] = "dark-grey";
  Color2["WHITE"] = "white";
  Color2["BLACK"] = "black";
  Color2["RED"] = "default-red";
  Color2["DARK_RED"] = "dark-red";
  return Color2;
})(Color || {});
function toColor(color) {
  if (color === "ccam") return "light-yellow";
  return color;
}
export {
  Color,
  toColor
};
//# sourceMappingURL=colors.js.map
